import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { AnimatePresence, motion } from 'framer-motion';
const faqs = [{
  question: '¿Sirve para cualquier rubro profesional?',
  answer: 'Sí. El sistema está diseñado para consultores, contadores, diseñadores, coaches, arquitectos, abogados y cualquier profesional que venda servicios por su conocimiento.'
}, {
  question: '¿Cómo recibo el material?',
  answer: 'Al completar el pago recibís acceso inmediato a toda la plataforma. En menos de 5 minutos tenés todo disponible.'
}, {
  question: '¿Necesito conocimientos previos?',
  answer: 'No. El contenido está diseñado para ser aplicado desde cero, paso a paso, sin experiencia previa en gestión ni ventas.'
}, {
  question: '¿Qué diferencia tiene el Bono 3 con otros cursos de IA?',
  answer: 'No es teoría. Son prompts específicos y flujos de trabajo concretos para las tareas de un profesional independiente — probados y listos para usar.'
}, {
  question: '¿La garantía es real?',
  answer: 'Sí. Tenés 21 días y devolución del 100%, en un proceso directo y sin excusas.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="bg-brand-lighter px-6 py-24 lg:px-8" data-id="element-75">
      <div className="mx-auto max-w-3xl" data-id="element-76">
        <h2 className="mb-12 text-center text-3xl font-extrabold text-brand-navy md:text-4xl" data-id="element-77">
          Preguntas frecuentes
        </h2>
        <div className="space-y-4" data-id="element-78">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <article key={faq.question} className="overflow-hidden rounded-2xl border border-brand-light bg-white" data-id="element-79">
                <button type="button" aria-expanded={isOpen} onClick={() => setOpenIndex(isOpen ? null : index)} className="flex w-full items-center justify-between gap-6 px-6 py-5 text-left font-bold text-brand-navy transition hover:bg-brand-lighter/50" data-id="element-80">
                  {faq.question}
                  <ChevronDown className={`h-5 w-5 shrink-0 text-brand-accent transition-transform ${isOpen ? 'rotate-180' : ''}`} data-id="element-81" />
                </button>
                <AnimatePresence initial={false} data-id="element-82">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} className="overflow-hidden px-6 pb-5 leading-relaxed text-brand-navy/70" data-id="element-83">
                      {faq.answer}
                    </motion.div>}
                </AnimatePresence>
              </article>;
        })}
        </div>
      </div>
    </section>;
}